import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';
import Snackbar from '@quintoandar/cozy-core/Snackbar';

import OnLoandingUpload from 'components/UploadImage/onLoadingUpload';

import withWidth from '@quintoandar/cozy-utils/hocs/withWidth';
import PhotosManagerContent from 'components/PhotosManagerContent';
import arrayMove from 'array-move';
import { createStructuredSelector } from 'reselect';
import withTheme from '@quintoandar/cozy-utils/hocs/withTheme';

import ErrorBoundary from 'components/ErrorBoundary';
import { logUncaught } from 'utils/log';

import {
  makeSelectPhotoList,
  makeSelectPhotoHasStartedUplaod,
  makeSelectLoadingUpload,
  makeSelectLoadingInitial,
  makeSelectLastUpload,
  makeSelectHasSnackbar,
  makeSelectSnackbarMessage,
  makeSelectSnackbarState,
  makeSelectRoomsSuggetions } from './selectors';
import {
  fetchPhotosAction,
  updatePhotosListAction,
  updateHasSnackBarAction,
  fetchRoomsSuggestionsAction } from './action';
import {
  changeEnabledButtonAction,
  changeBottomButtonPayloadAction,
} from '../../containers/AnnouncementSteps/actions';

export const PhotosManager = ({
  params,
  hasStartedUpdloadPhoto,
  photoList,
  fetchPhotos,
  updatePhotoList,
  hasNotDataUploadedBeenRetrived,
  hasNotInitialDataBeenRetrived,
  lastUpload,
  updateHasSnackBar,
  hasSnackbar,
  snackbarState,
  snackbarMessage,
  changeEnabledButton,
  additionalProps,
  galleryType,
  changeBottomButtonPayload,
  fetchRoomsSuggestions,
  roomsSuggestions,
}) => {
  const [loading, setLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleOnClose = useCallback(() => {
    updateHasSnackBar(false);
  }, []);

  useEffect(() => () => {
    updateHasSnackBar(false);
  }, []);

  useEffect(() => {
    changeEnabledButton(true);
  }, []);

  useEffect(() => {
    setLoading(hasNotInitialDataBeenRetrived);
  }, [hasNotInitialDataBeenRetrived]);

  useEffect(() => {
    setLoading(hasNotInitialDataBeenRetrived);
    setUploadLoading(hasNotDataUploadedBeenRetrived);
    changeBottomButtonPayload(photoList);
  }, [photoList]);

  useEffect(() => {
    fetchPhotos(
      additionalProps.houseType || params.house_type,
      additionalProps.houseId || params.house_id,
      galleryType
    );
  }, [lastUpload]);

  useEffect(() => {
    if (roomsSuggestions.length === 0) {
      fetchRoomsSuggestions();
    }
  }, []);

  const onSortEnd = useCallback(({ oldIndex, newIndex }) => {
    const sortList = arrayMove(photoList, oldIndex, newIndex);
    updatePhotoList(sortList);
  }, [photoList]);

  return (
    <Box>
      {photoList?.length > 0 ? (
        <Box>
          <PhotosManagerContent
            galleryType={galleryType}
            onSortEnd={onSortEnd}
            photos={photoList}
            distance={1}
            houseId={additionalProps.houseId || params.house_id}
            houseType={additionalProps.houseType || params.house_type}
            axis="xy"
          />
        </Box>
      ) : (
        <OnLoandingUpload
          galleryType={galleryType}
          houseType={additionalProps.houseType || params.house_type}
          houseId={additionalProps.houseId || params.house_id}
          hasNotDataUploadedBeenRetrived={uploadLoading}
          hasNotInitialDataBeenRetrived={loading}
          hasStartedUpdloadPhoto={hasStartedUpdloadPhoto}
        />
      )}
      <ErrorBoundary errorComponent={null} logError={logUncaught}>
        <Snackbar
          open={hasSnackbar}
          onClose={handleOnClose}
          message={snackbarMessage}
          autoHideDuration={4000}
          color={snackbarState}
        />
      </ErrorBoundary>
    </Box>
  );
};

PhotosManager.propTypes = {
  params: PropTypes.shape({
    house_type: PropTypes.string,
    house_id: PropTypes.number,
  }),
  additionalProps: PropTypes.shape({
    houseType: PropTypes.string,
    houseId: PropTypes.number,
    photoSessionId: PropTypes.number,
  }),
  galleryType: PropTypes.string,
  fetchPhotos: PropTypes.func,
  fetchRoomsSuggestions: PropTypes.func,
  updatePhotoList: PropTypes.func,
  photoList: PropTypes.array,
  hasStartedUpdloadPhoto: PropTypes.bool,
  hasNotDataUploadedBeenRetrived: PropTypes.bool,
  hasNotInitialDataBeenRetrived: PropTypes.bool,
  lastUpload: PropTypes.number,
  updateHasSnackBar: PropTypes.func,
  hasSnackbar: PropTypes.bool,
  snackbarMessage: PropTypes.string,
  snackbarState: PropTypes.string,
  changeEnabledButton: PropTypes.func,
  changeBottomButtonPayload: PropTypes.func,
  roomsSuggestions: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
  photoList: makeSelectPhotoList(),
  hasStartedUpdloadPhoto: makeSelectPhotoHasStartedUplaod(),
  hasNotDataUploadedBeenRetrived: makeSelectLoadingUpload(),
  hasNotInitialDataBeenRetrived: makeSelectLoadingInitial(),
  lastUpload: makeSelectLastUpload(),
  hasSnackbar: makeSelectHasSnackbar(),
  snackbarMessage: makeSelectSnackbarMessage(),
  snackbarState: makeSelectSnackbarState(),
  roomsSuggestions: makeSelectRoomsSuggetions(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchPhotos: (houseType, houseId, galleryType) => dispatch(fetchPhotosAction(houseType, houseId, galleryType)),
  updatePhotoList: (photospheres) => dispatch(updatePhotosListAction(photospheres)),
  updateHasSnackBar: (state) => dispatch(updateHasSnackBarAction(state)),
  changeEnabledButton: (enabledButton) => dispatch(changeEnabledButtonAction(enabledButton)),
  changeBottomButtonPayload: (payload) => dispatch(changeBottomButtonPayloadAction(payload)),
  fetchRoomsSuggestions: () => dispatch(fetchRoomsSuggestionsAction()),
});

export default compose(
  withTheme,
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(PhotosManager);
